import { Component, OnInit } from '@angular/core';

import { AuthService, BreakpointService, ConfigService, SessionService } from '@services';
import { NavToolbarService } from '../../../helpers/navtoolbar.service';
import { BaseComponent } from '../../../../base.component';
import { UsersService } from '@mzima-client/sdk';

@Component({
  selector: 'app-account-and-logout',
  templateUrl: './account-and-logout.component.html',
  styleUrls: ['./account-and-logout.component.scss'],
})
export class AccountAndLogoutComponent extends BaseComponent implements OnInit {
  public userPhoto: string = '//www.gravatar.com/avatar/00000000000000000000000000000000?d=retro&s=64';

  constructor(
    protected override sessionService: SessionService,
    protected override breakpointService: BreakpointService,
    private configService: ConfigService,
    private authService: AuthService,
    private navToolbarService: NavToolbarService,
    private usersService: UsersService,
  ) {
    super(sessionService, breakpointService);
    this.checkDesktop();
  }

  ngOnInit(): void {
    this.getUserData();
  }

  loadData(): void {
    this.userPhoto = `//www.gravatar.com/avatar/${
      this.user.gravatar || '00000000000000000000000000000000'
    }?d=retro&s=64`;
    if (this.user.userId) {
      this.usersService.getUserSettings(this.user.userId).subscribe({
        next: (response: any) => {
          const photoSetting = response.results?.find(
            (s: any) => s.config_key === 'profile_photo',
          );
          if (photoSetting?.config_value?.photo_url) {
            this.userPhoto = photoSetting.config_value.photo_url;
          }
        },
        error: () => {},
      });
    }
  }

  public openAccountSettings(): void {
    this.navToolbarService.openAccountSettings();
  }

  public logout(): void {
    this.authService.logout();
    this.configService.initAllConfigurations();
  }
}
